import { Candidate } from 'redux/ATS/jobs/actions'
import { PaginationTypes } from 'types/sharedResponse'

export const GET_JOB_APPLICANTS = 'GET_JOB_APPLICANTS'
export const GET_JOB_APPLICANTS_PENDING = 'GET_JOB_APPLICANTS_PENDING'
export const GET_JOB_APPLICANTS_FULFILLED = 'GET_JOB_APPLICANTS_FULFILLED'
export const GET_JOB_APPLICANTS_REJECTED = 'GET_JOB_APPLICANTS_REJECTED'

export const CREATE_JOB_APPLICANT = 'CREATE_JOB_APPLICANT'
export const CREATE_JOB_APPLICANT_PENDING = 'CREATE_JOB_APPLICANT_PENDING'
export const CREATE_JOB_APPLICANT_FULFILLED = 'CREATE_JOB_APPLICANT_FULFILLED'
export const CREATE_JOB_APPLICANT_REJECTED = 'CREATE_JOB_APPLICANT_REJECTED'

export type JobApplication = {
  id: number
  created_at: string
  updated_at: string
  candidate_id: number
  job_id: number
  job_workflow_stage_id: number
  organization_id: number
}

export type CreateJobApplicationResponse = {
  data: {
    job_application: JobApplication
    message: string
  }
  success?: boolean
  statusCode?: number | null
}

export type JobApplicantCandidate = Pick<
  Candidate,
  'name_ar' | 'name_en' | 'name_i18n' | 'current_role' | 'id' | 'cv_file_fields' | 'comment_count'
> & {
  job_application: {
    id: number
    source: string
    source_i18n: string
    created_at: string
    updated_at: string
  }
  job_application_ids: string[]
}

export type WorkflowStages = {
  count: number
  stage_id: number
  stage_name: string
  stage_name_i18n: string
  job_application_ids: string[]
  candidates: JobApplicantCandidate[]
}

export type JobApplicant = {
  workflow_stages: WorkflowStages[]
  all_candidate_ids: number[]
  pagination?: PaginationTypes
}

export type JobApplicantResponse = {
  data: JobApplicant
  success: boolean
  statusCode: number
}

export type JobApplicantRequest = {
  search?: string
  page?: number
  rpp?: number
}
